/* TYJ Clean-Look – gemeinsames Verhalten */
(function () {
  if (window.tyjClean) return;
  window.tyjClean = true;

  function cartDrawer() { return document.querySelector('cart-drawer'); }

  function addToCart(items, btn) {
    var drawer = cartDrawer();
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (btn) btn.classList.add('is-loading');
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (btn) btn.classList.remove('is-loading');
      if (res.status) { alertText(btn, res.description || 'Leider nicht verfügbar.'); return; }
      if (btn) { btn.classList.add('is-added'); btn.setAttribute('aria-label', 'Im Warenkorb'); }
      if (drawer && drawer.renderContents && res.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        document.dispatchEvent(new CustomEvent('tyj:cart-updated'));
      }
    }).catch(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function alertText(btn, msg) {
    if (!btn) return;
    var live = document.getElementById('tyj-live') || (function () {
      var d = document.createElement('div'); d.id = 'tyj-live'; d.className = 'tc-visually-hidden'; d.setAttribute('aria-live', 'polite'); document.body.appendChild(d); return d;
    })();
    live.textContent = msg;
    btn.title = msg;
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-tyj-add]');
    if (add) {
      e.preventDefault();
      var ids = add.getAttribute('data-tyj-add').split(',').filter(Boolean);
      var rawItems = add.getAttribute('data-tyj-items'), items = null;
      if (rawItems) { try { items = JSON.parse(rawItems); } catch (err) { items = null; } }
      addToCart(items || ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), add);
      return;
    }
    var tab = e.target.closest('[data-tyj-tab]');
    if (tab) {
      var root = tab.closest('[data-tyj-tabs]');
      var key = tab.getAttribute('data-tyj-tab');
      root.querySelectorAll('[data-tyj-tab]').forEach(function (t) {
        var on = t.getAttribute('data-tyj-tab') === key;
        t.setAttribute(t.getAttribute('role') === 'tab' ? 'aria-selected' : 'aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-tyj-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-tyj-panel') !== key; });
      root.dispatchEvent(new CustomEvent('tyj:tab', { detail: key }));
      return;
    }
    var more = e.target.closest('[data-tyj-more]');
    if (more) {
      var panel = more.closest('[data-tyj-panel]') || more.parentElement.parentElement;
      panel.querySelectorAll('[data-tyj-extra]').forEach(function (x) { x.hidden = false; });
      more.hidden = true;
      var link = panel.querySelector('[data-tyj-alllink]');
      if (link) link.hidden = false;
      return;
    }
    var notify = e.target.closest('[data-tyj-notify]');
    if (notify && notify.tagName === 'BUTTON') {
      var on = notify.getAttribute('aria-pressed') !== 'true';
      notify.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) window.location.href = notify.getAttribute('data-tyj-notify');
    }
  });

  // Formular-Prüfung (Kontakt, Widerruf)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-tyj-validate]');
    if (!form) return;
    var ok = true;
    form.querySelectorAll('[data-tyj-required]').forEach(function (f) {
      var v = (f.value || '').trim();
      var bad = !v || (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
      f.setAttribute('aria-invalid', bad ? 'true' : 'false');
      var err = form.querySelector('[data-tyj-err="' + f.name + '"]');
      if (err) err.hidden = !bad;
      if (bad && ok) { f.focus(); ok = false; }
    });
    if (!ok) e.preventDefault();
  });
  document.addEventListener('input', function (e) {
    var f = e.target;
    if (f.getAttribute && f.getAttribute('aria-invalid') === 'true' && (f.value || '').trim()) {
      f.setAttribute('aria-invalid', 'false');
      var form = f.closest('form'); var err = form && form.querySelector('[data-tyj-err="' + f.name + '"]');
      if (err) err.hidden = true;
    }
  });

  // Wisch-Fortschritt (Kategorien)
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el.getAttribute || !el.hasAttribute('data-tyj-swipe')) return;
    var thumb = document.getElementById(el.getAttribute('data-tyj-swipe'));
    var max = el.scrollWidth - el.clientWidth;
    if (thumb) thumb.style.left = (max > 0 ? Math.min(Math.max(el.scrollLeft / max, 0), 1) * 60 : 0) + '%';
  }, true);

  // Sortieren/Filter automatisch absenden
  document.addEventListener('change', function (e) {
    var f = e.target.closest('[data-tyj-autosubmit]');
    if (f) f.form ? f.form.submit() : f.closest('form').submit();
  });
})();

/* Warenkorb: "Passt perfekt dazu" aus Shopify-Empfehlungen (ergänzend, dann ähnlich) */
(function () {
  if (window.tyjUps) return;
  window.tyjUps = true;
  var cache = {};
  var MAX = 3;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents, f) {
    var a = (cents / 100).toFixed(2);
    f = f || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return a.replace('.', ',');
      if (k.indexOf('no_decimals') > -1) return String(Math.round(cents / 100));
      return a;
    });
  }
  function get(id, intent) {
    var k = id + ':' + intent;
    if (!cache[k]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      cache[k] = fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=8&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }
    return cache[k];
  }
  function card(p, fmt, left, goal) {
    var vs = p.variants || [];
    var v = vs.filter(function (x) { return x.available; })[0] || vs[0];
    if (!v) return '';
    var src = p.featured_image || '';
    if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    var btn = vs.length === 1
      ? '<button type="button" class="tc-up tc-upc__btn" data-tyj-add="' + v.id + '" aria-label="In den Warenkorb: ' + esc(p.title) + '">+ Hinzufügen</button>'
      : '<a href="' + esc(p.url) + '" class="tc-upc__btn">Auswählen</a>';
    return '<div class="tc-upc" data-tc-pid="' + p.id + '">' +
      '<a href="' + esc(p.url) + '" class="tc-upc__img" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
      ((left > 0 && v.price >= left) ? '<span class="tc-upc__badge" title="Mit diesem Produkt erreichst du ' + esc(goal) + ' – deine ganze Bestellung wird versandkostenfrei">' + esc(goal) + ' erreicht</span>' : '') +
      '<a href="' + esc(p.url) + '" class="tc-upc__name">' + esc(p.title) + '</a>' +
      '<span class="tc-upc__price">' + esc(money(v.price, fmt)) + '</span>' + btn + '</div>';
  }
  function load(box) {
    if (box.getAttribute('data-tc-done')) return;
    box.setAttribute('data-tc-done', '1');
    var ids = (box.getAttribute('data-src') || '').split(',').filter(Boolean).slice(0, 3);
    var grid = box.querySelector('[data-tc-ups-grid]');
    if (!ids.length || !grid) return;
    var inCart = box.getAttribute('data-in-cart') || '';
    var jobs = [];
    ids.forEach(function (id) { jobs.push(get(id, 'complementary'), get(id, 'related')); });
    Promise.all(jobs).then(function (lists) {
      var comp = [], rel = [];
      lists.forEach(function (l, i) { (i % 2 ? rel : comp).push(l); });
      var out = [], seen = {};
      function take(groups) {
        var len = 0;
        groups.forEach(function (g) { len = Math.max(len, g.length); });
        for (var i = 0; i < len && out.length < MAX; i++) {
          groups.forEach(function (g) {
            var p = g[i];
            if (!p || out.length >= MAX || seen[p.id] || !p.available) return;
            if (inCart.indexOf(',' + p.id + ',') > -1) return;
            seen[p.id] = 1; out.push(card(p, box.getAttribute('data-money'), Number(box.getAttribute('data-left')) || 0, box.getAttribute('data-goal') || '40 €'));
          });
        }
      }
      take(comp); take(rel);
      if (!out.length) return;
      [].slice.call(grid.querySelectorAll('[data-tc-pid]')).forEach(function (c) {
        if (out.length < MAX && !seen[c.getAttribute('data-tc-pid')]) out.push(c.outerHTML);
      });
      grid.innerHTML = out.join('');
      var hint = box.querySelector('[data-tc-ups-hint]');
      if (hint) hint.hidden = !grid.querySelector('.tc-upc__badge');
      box.hidden = false;
    });
  }
  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('[data-tc-ups]').forEach(load);
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Wishlist "Meine Lieblinge": Herz-Buttons, Pinnwand-Panel von links, Teilen, Sale/Wieder-da-Hinweise (Speicher: Browser der Kundin) */
(function tcWishlist() {
  if (window.tyjWish) return;
  window.tyjWish = true;
  var KEY = 'tyj-wish-v1', CACHE = 'tyj-wish-cache-v1', GOAL = 4000, MAX = 40;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.3s-7.4-4.5-9.2-9.1C1.6 8 3.7 4.6 7.2 4.6c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.5 0 5.6 3.4 4.4 6.6-1.8 4.6-9.2 9.1-9.2 9.1z"/></svg>';
  var XICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var BAG = '<svg width="16" height="16" viewBox="0 0 100 100" fill="currentColor" aria-hidden="true"><path stroke="currentColor" stroke-width="2.5" d="m50.078 9.042a11.4 11.4 0 0 0 -11.378 11.383v8.888h-23.274a1.25 1.25 0 0 0 -1.25 1.25v57.475a1.249 1.249 0 0 0 1.25 1.25h69.3a1.249 1.249 0 0 0 1.25-1.25v-57.475a1.25 1.25 0 0 0 -1.25-1.25h-23.264v-8.888a11.4 11.4 0 0 0 -11.384-11.383zm-8.878 11.383a8.884 8.884 0 0 1 17.767 0v8.884h-17.767zm42.281 66.363h-66.8v-54.975h22.019v5.069a1.25 1.25 0 0 0 2.5 0v-5.069h17.762v5.069a1.25 1.25 0 0 0 2.5 0v-5.069h22.019z"/></svg>';
  var SHARE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15V4M8 8l4-4 4 4M5 13v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function load() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function store(l) { try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, MAX))); } catch (e) {} }
  function save(l) { store(l); update(); }
  function has(h) { return load().some(function (x) { return x.h === h; }); }
  function cacheGet() { try { return JSON.parse(sessionStorage.getItem(CACHE) || '{}'); } catch (e) { return {}; } }
  function cacheSet(c) { try { sessionStorage.setItem(CACHE, JSON.stringify(c)); } catch (e) {} }
  function img(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var mem = {};
  function product(h) {
    if (mem[h]) return mem[h];
    var e = cacheGet()[h];
    if (e && Date.now() - e.t < 20 * 60 * 1000) { mem[h] = Promise.resolve(e.d); return mem[h]; }
    mem[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var vs = p.variants || [];
        var d = { h: p.handle, title: p.title, url: p.url, img: p.featured_image || '', price: p.price, cmp: p.compare_at_price || 0, av: !!p.available,
          vars: vs.map(function (v) { return { id: v.id, av: v.available, price: v.price }; }), single: vs.length === 1 };
        var cc = cacheGet(); cc[h] = { t: Date.now(), d: d }; cacheSet(cc);
        return d;
      }).catch(function () { return null; });
    return mem[h];
  }
  var bestP;
  function bestsellers() {
    if (!bestP) bestP = fetch(root + 'collections/unsere-bestseller/products.json?limit=12')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        return (d.products || []).map(function (p) {
          var vs = p.variants || [];
          var v = vs.filter(function (x) { return x.available; })[0] || vs[0] || {};
          return { h: p.handle, title: p.title, url: root + 'products/' + p.handle, img: (p.images && p.images[0] && p.images[0].src) || '',
            price: Math.round(parseFloat(v.price || 0) * 100), cmp: Math.round(parseFloat(v.compare_at_price || 0) * 100), av: vs.some(function (x) { return x.available; }) };
        }).filter(function (p) { return p.av; });
      }).catch(function () { return []; });
    return bestP;
  }
  function status(item, d) {
    if (!d) return '';
    if (!d.av) return 'out';
    if (item.a === false) return 'back';
    if (d.cmp > d.price || (item.p && d.price < item.p)) return 'sale';
    return '';
  }
  function update() {
    var l = load(), set = {};
    l.forEach(function (x) { set[x.h] = 1; });
    document.querySelectorAll('[data-tc-wish]').forEach(function (b) {
      var on = !!set[b.getAttribute('data-tc-wish')];
      if (b.getAttribute('aria-pressed') !== String(on)) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', (on ? 'Von der Wishlist entfernen: ' : 'Auf die Wishlist: ') + (b.getAttribute('data-title') || ''));
      }
    });
    document.querySelectorAll('[data-tc-wish-count]').forEach(function (c) { c.textContent = l.length; c.hidden = !l.length; });
    if (wl && !wl.hidden) { var cnt = wl.querySelector('[data-tc-wl-count]'); if (cnt && mode === 'mine') cnt.textContent = l.length; }
  }
  function setDot(on) { document.querySelectorAll('[data-tc-wish-dot]').forEach(function (d) { d.hidden = !on; }); }
  function checkDot() {
    var l = load();
    if (!l.length) { setDot(false); return; }
    Promise.all(l.map(function (x) { return product(x.h); })).then(function (ds) {
      var any = false;
      ds.forEach(function (d, i) { var s = status(l[i], d); if ((s === 'back' || s === 'sale') && l[i].seen !== s + ':' + d.price) any = true; });
      setDot(any);
    });
  }
  function toggle(h, btn) {
    var l = load(), i = -1, inPanel = wl && !wl.hidden && wl.contains(btn);
    l.forEach(function (x, k) { if (x.h === h) i = k; });
    if (btn) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
    if (i > -1) {
      l.splice(i, 1); save(l);
      if (inPanel && mode === 'mine') { var card = btn.closest('.tc-wl__card'); if (card) { card.classList.add('is-gone'); setTimeout(render, 220); } else render(); }
      else toast('Von deiner Wishlist entfernt', false);
      return;
    }
    l.unshift({ h: h, t: Date.now() }); save(l);
    product(h).then(function (d) {
      if (!d) return;
      var L = load();
      L.forEach(function (x) { if (x.h === h && x.p == null) { x.p = d.price; x.a = d.av; } });
      store(L);
    });
    if (inPanel && mode === 'mine') setTimeout(render, 350);
    else if (!inPanel) toast('Auf deine Wishlist gelegt', true);
  }
  var toastEl, toastT;
  function toast(msg, withLink) {
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'tc-toast';
      toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span class="tc-toast__heart">' + HEART + '</span><span>' + esc(msg) + '</span>' + (withLink ? '<button type="button" data-tc-toast-open>Ansehen</button>' : '');
    toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  var wl, lastFocus, mode = 'mine', shared = [];
  function build() {
    if (wl) return;
    wl = document.createElement('div'); wl.className = 'tc-wl'; wl.hidden = true;
    wl.innerHTML = '<div class="tc-wl__overlay" data-tc-wl-close></div><aside class="tc-wl__panel" role="dialog" aria-modal="true" aria-labelledby="tc-wl-title" tabindex="-1"><header class="tc-wl__head"><span class="tc-wl__mark" aria-hidden="true">' + HEART + '</span><p id="tc-wl-title" class="tc-wl__title"></p><button type="button" class="tc-wl__x" data-tc-wl-close aria-label="Wishlist schließen">' + XICON + '</button></header><div class="tc-wl__body" data-tc-wl-body></div><footer class="tc-wl__foot" data-tc-wl-foot></footer></aside>';
    document.body.appendChild(wl);
    wl.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function open(m) {
    build(); mode = m || 'mine';
    lastFocus = document.activeElement;
    wl.hidden = false;
    requestAnimationFrame(function () { wl.classList.add('is-open'); });
    document.body.classList.add('overflow-hidden');
    render();
    wl.querySelector('.tc-wl__panel').focus();
  }
  function close(keepFocus) {
    if (!wl || wl.hidden) return;
    wl.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    var L = load(), changed = false;
    L.forEach(function (x) { var d = cacheGet()[x.h]; if (d && x.a === false && d.d.av) { x.a = true; changed = true; } });
    if (changed) store(L);
    setTimeout(function () { wl.hidden = true; }, 260);
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function heartBtn(d) {
    var on = has(d.h);
    return '<button type="button" class="tc-heart tc-wl__heart" data-tc-wish="' + esc(d.h) + '" data-title="' + esc(d.title) + '" aria-pressed="' + on + '" aria-label="' + (on ? 'Von der Wishlist entfernen: ' : 'Auf die Wishlist: ') + esc(d.title) + '">' + HEART + '</button>';
  }
  function cardHtml(d, s, v, simple) {
    var badge = s === 'sale' ? '<span class="tc-wl__badge tc-wl__badge--sale">Jetzt reduziert</span>'
      : s === 'back' ? '<span class="tc-wl__badge tc-wl__badge--back">Wieder da</span>'
      : s === 'out' ? '<span class="tc-wl__badge">Bald da</span>' : '';
    var onSale = d.cmp > d.price;
    var price = '<span class="tc-wl__price' + (onSale ? ' is-sale' : '') + '">' + money(d.price) + (onSale ? ' <s>' + money(d.cmp) + '</s>' : '') + '</span>';
    var act = '';
    if (!simple) {
      act = !d.av ? '<a class="tc-wl__btn" href="' + esc(d.url) + '">Benachrichtigen</a>'
        : (d.single && v ? '<button type="button" class="tc-wl__btn" data-tc-wl-add="' + v.id + '" aria-label="In den Warenkorb: ' + esc(d.title) + '">' + BAG + '<span>In den Warenkorb</span></button>'
        : '<a class="tc-wl__btn" href="' + esc(d.url) + '">Auswählen</a>');
    }
    var keep = mode === 'shared' && !simple ? '<button type="button" class="tc-wl__keep" data-tc-wl-keep="' + esc(d.h) + '">' + (has(d.h) ? 'Gemerkt' : 'Auch merken') + '</button>' : '';
    return '<div class="tc-wl__media"><a class="tc-wl__img" href="' + esc(d.url) + '" tabindex="-1" aria-hidden="true">' + (d.img ? '<img src="' + esc(img(d.img, 300)) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</a>' + badge + (mode === 'shared' && !simple ? '' : heartBtn(d)) + '</div>' +
      '<a class="tc-wl__name" href="' + esc(d.url) + '">' + esc(d.title) + '</a>' + price + act + keep;
  }
  function renderEmpty(body, foot) {
    body.innerHTML = '<div class="tc-wl__empty"><p class="tc-wl__empty-t">Deine Wishlist ist noch leer</p><p>Tippe auf das Herz, um Produkte hier zu sammeln. Zum Beispiel bei unseren Bestsellern:</p></div><ul class="tc-wl__grid" data-tc-wl-best></ul>';
    foot.innerHTML = '';
    bestsellers().then(function (ps) {
      var ul = body.querySelector('[data-tc-wl-best]');
      if (!ul) return;
      ul.innerHTML = ps.slice(0, 4).map(function (d) { return '<li class="tc-wl__card">' + cardHtml(d, '', null, true) + '</li>'; }).join('');
    });
  }
  function render() {
    if (!wl) return;
    var body = wl.querySelector('[data-tc-wl-body]'), foot = wl.querySelector('[data-tc-wl-foot]'), title = wl.querySelector('#tc-wl-title');
    var list = mode === 'shared' ? shared.map(function (h) { return { h: h }; }) : load();
    title.innerHTML = mode === 'shared' ? 'Ein <em>Wunschzettel</em> für dich' : 'Meine <em>Wishlist</em>' + (list.length ? ' <span class="tc-wl__count" data-tc-wl-count>' + list.length + '</span>' : '');
    if (!list.length) { renderEmpty(body, foot); return; }
    body.innerHTML = (mode === 'shared' ? '<p class="tc-wl__intro">Jemand hat dir diese Wünsche geschickt. Perfekt als Geschenk.</p>' : '') +
      '<div class="tc-wl__ship" data-tc-wl-ship></div>' +
      (mode === 'shared' ? '' : '<p class="tc-wl__wish">Ich wünsche mir …</p>') +
      '<ul class="tc-wl__grid">' + list.map(function (x) { return '<li class="tc-wl__card is-loading" data-h="' + esc(x.h) + '"></li>'; }).join('') + '</ul>';
    foot.innerHTML = (mode === 'shared'
        ? '<button type="button" class="tc-wl__fbtn tc-wl__fbtn--light" data-tc-wl-mine>Meine Wishlist</button>'
        : '<button type="button" class="tc-wl__fbtn tc-wl__fbtn--light" data-tc-wl-share aria-expanded="false">' + SHARE + '<span>Teilen</span></button>') +
      '<button type="button" class="tc-wl__fbtn" data-tc-wl-all disabled>' + BAG + '<span>Alle in den Warenkorb</span></button>' +
      (mode === 'shared' ? '' : '<div class="tc-wl__shareopts" data-tc-wl-shareopts hidden></div>');
    Promise.all([
      Promise.all(list.map(function (x) { return product(x.h); })),
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).catch(function () { return { total_price: 0, items: [] }; })
    ]).then(function (res) {
      var ds = res[0], cart = res[1], inCart = {}, ids = [], sum = 0, mv = 0;
      (cart.items || []).forEach(function (i) { inCart[i.variant_id] = 1; });
      ds.forEach(function (d, i) {
        var li = body.querySelector('.tc-wl__card[data-h="' + list[i].h + '"]');
        if (!li) return;
        li.classList.remove('is-loading');
        if (!d) { li.remove(); return; }
        var s = mode === 'shared' ? (d.av ? '' : 'out') : status(list[i], d);
        var v = d.vars.filter(function (x) { return x.av; })[0];
        if (d.av && v && !d.vars.some(function (x) { return inCart[x.id]; })) { if (d.single) ids.push(v.id); else mv++; sum += d.vars.filter(function (x) { return x.av; }).reduce(function (m, x) { return Math.min(m, x.price); }, v.price); }
        li.innerHTML = cardHtml(d, s, v, false);
      });
      var tot = (cart.items || []).reduce(function (s, it) { return s + (it.gift_card ? 0 : it.final_line_price); }, 0), withAll = tot + sum, txt;
      if (tot >= GOAL) txt = 'Dein Versand ist schon kostenlos.';
      else if (!ids.length && !mv) txt = 'Noch ' + money(GOAL - tot) + ' bis zum Gratis-Versand.';
      else if (withAll >= GOAL) txt = 'Mit deiner ganzen Wishlist im Warenkorb ist deine ganze Bestellung versandkostenfrei.';
      else txt = 'Mit deiner ganzen Wishlist fehlen nur noch ' + money(GOAL - withAll) + ' bis zum Gratis-Versand.';
      var pct = Math.min(100, Math.round(withAll / GOAL * 100));
      var ship = body.querySelector('[data-tc-wl-ship]');
      if (ship) ship.innerHTML = '<p>' + txt + '</p><div class="tc-wl__bar" role="progressbar" aria-label="Fortschritt bis zum kostenlosen Versand" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
      var all = foot.querySelector('[data-tc-wl-all]');
      if (all) {
        if (ids.length) { all.disabled = false; all.setAttribute('data-ids', ids.join(',')); all.querySelector('span').textContent = 'Alle in den Warenkorb (' + ids.length + ')'; all.setAttribute('aria-label', 'Alle ' + ids.length + ' in den Warenkorb, zusammen ' + money(sum)); }
        else all.hidden = true;
      }
      if (mode === 'mine') {
        var L = load(), hs = list.map(function (y) { return y.h; });
        L.forEach(function (x) { var d = ds[hs.indexOf(x.h)]; if (d) { var s = status(x, d); if (s === 'back' || s === 'sale') x.seen = s + ':' + d.price; } });
        store(L); setDot(false);
      }
    });
  }
  function addCart(ids) {
    if (!ids) return;
    close(true);
    var t = document.createElement('button');
    t.type = 'button'; t.hidden = true; t.setAttribute('data-tyj-add', ids);
    document.body.appendChild(t);
    setTimeout(function () { t.click(); setTimeout(function () { t.remove(); }, 4000); }, 280);
  }
  function shareUrl(list) {
    var hs = list.map(function (x) { return x.h; }).slice(0, 25);
    return location.origin + root + '?wunschzettel=' + hs.join(',');
  }
  function share(btn) {
    var o = wl.querySelector('[data-tc-wl-shareopts]');
    if (!o) return;
    var url = shareUrl(load()), text = "Mein Wunschzettel bei That's your Journal:";
    o.innerHTML = '<a class="tc-wl__opt" href="https://wa.me/?text=' + encodeURIComponent(text + ' ' + url) + '" target="_blank" rel="noopener">Per WhatsApp</a>' +
      '<button type="button" class="tc-wl__opt" data-tc-wl-copy="' + esc(url) + '">Link kopieren</button>' +
      (navigator.share ? '<button type="button" class="tc-wl__opt tc-wl__opt--wide" data-tc-wl-native>Weitere Apps</button>' : '');
    o.hidden = !o.hidden;
    btn.setAttribute('aria-expanded', o.hidden ? 'false' : 'true');
    o._share = { title: 'Mein Wunschzettel', text: text, url: url };
  }
  function copy(btn) {
    var u = btn.getAttribute('data-tc-wl-copy');
    var p = navigator.clipboard ? navigator.clipboard.writeText(u) : Promise.reject();
    p.then(function () { btn.textContent = 'Link kopiert'; }).catch(function () { window.prompt('Link kopieren:', u); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tc-wish]');
    if (b) { e.preventDefault(); e.stopPropagation(); toggle(b.getAttribute('data-tc-wish'), b); return; }
    if (e.target.closest('[data-tc-wish-open]') || e.target.closest('[data-tc-toast-open]')) { e.preventDefault(); open('mine'); return; }
    if (!wl || !wl.contains(e.target)) return;
    if (e.target.closest('[data-tc-wl-close]')) { close(); return; }
    var a = e.target.closest('[data-tc-wl-add]');
    if (a) { addCart(a.getAttribute('data-tc-wl-add')); return; }
    var all = e.target.closest('[data-tc-wl-all]');
    if (all) { addCart(all.getAttribute('data-ids')); return; }
    var keep = e.target.closest('[data-tc-wl-keep]');
    if (keep) { var h2 = keep.getAttribute('data-tc-wl-keep'); if (!has(h2)) { var l = load(); l.unshift({ h: h2, t: Date.now() }); save(l); } keep.textContent = 'Gemerkt'; return; }
    if (e.target.closest('[data-tc-wl-mine]')) { mode = 'mine'; render(); return; }
    var sh = e.target.closest('[data-tc-wl-share]');
    if (sh) { share(sh); return; }
    var cp = e.target.closest('[data-tc-wl-copy]');
    if (cp) { copy(cp); return; }
    var nat = e.target.closest('[data-tc-wl-native]');
    if (nat) { var o = wl.querySelector('[data-tc-wl-shareopts]'); if (o && o._share) navigator.share(o._share).catch(function () {}); }
  }, true);
  function pdp() {
    document.querySelectorAll('[data-tc-pdp-wish]').forEach(function (m) {
      if (m.getAttribute('data-done')) return;
      m.setAttribute('data-done', '1');
      var t = document.querySelector('[id^="MainProduct-"] .product__title') || document.querySelector('.product__title');
      if (!t) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tc-heart tc-heart--pdp';
      b.setAttribute('data-tc-wish', m.getAttribute('data-tc-pdp-wish'));
      b.setAttribute('data-title', m.getAttribute('data-title') || '');
      b.innerHTML = HEART;
      t.classList.add('tc-has-heart'); t.appendChild(b);
    });
  }
  function initShared() {
    try {
      var q = new URLSearchParams(location.search).get('wunschzettel');
      if (!q) return;
      shared = q.split(',').map(function (s) { return s.trim(); }).filter(function (s) { return /^[a-z0-9-]+$/i.test(s); }).slice(0, 25);
      var u = new URL(location.href); u.searchParams.delete('wunschzettel'); history.replaceState(null, '', u.toString());
      if (shared.length) open('shared');
    } catch (e) {}
  }
  var queued = false;
  function scan() { queued = false; pdp(); update(); }
  function start() { scan(); checkDot(); initShared(); new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(scan); } }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
